<template>
  <div>
    <div class="header">
      <div class="top">
        <div class="title">
          全国国际象棋等级考试指定网站
        </div>
      </div>
    </div>
    <div class="container">
      <div class="dotest">
        <div class="left">象棋{{levelexam}}考试</div>
        <div class="right">考试剩余时间：<span class="time">{{countDownMinute}}:{{countDownSecond}}</span></div>
      </div>
      <div class="dotest_content">
        <div class="item_left">
          <div class="info">
            <div class="item_title">考生信息</div>
            <div class="item_info">考生姓名：{{name}}</div>
            <div class="item_info">考试时间：{{minute}}分钟</div>
            <div class="item_info">考试题数：{{questionNum}}</div>
            <div class="item_info">通过标准：{{questionNum*0.6}}/{{questionNum}}</div>
          </div>
          <div class="select" >
            <div class="item_choose" v-for="(item,index) in enrollItemBanks" :key="index"
                 :class="index === testIndex ? 'item_chooses' :''"
                 :style="{background:item.color}"
                 @click="toTegional(index)">{{index + 1}}</div>
          </div>
        </div>
        <div class="item-rigts">
          <div class="cons" v-if="enrollItemBanks[testIndex]">
            <div class="testtitle"><span>{{testIndex + 1}}.</span>{{enrollItemBanks[testIndex].title}}</div>
            <div class="testimg" v-show="enrollItemBanks[testIndex].image">
              <img :src="enrollItemBanks[testIndex].image">
            </div>
            <div class="selected"><span>A、</span>{{enrollItemBanks[testIndex].answerA}}</div>
            <div class="selected"><span>B、</span>{{enrollItemBanks[testIndex].answerB}}</div>
            <div class="selected"><span>C、</span>{{enrollItemBanks[testIndex].answerC}}</div>
          </div>
          <div class="selects">
            <div class="item_circle">
              <div class="circle" :class="selectA ? 'circles' :''" @click="chooseSelectA('A', enrollItemBanks[testIndex].rightKey)"></div>
              <span>A</span>
            </div>
            <div class="item_circle">
              <div class="circle" :class="selectB ? 'circles' :''" @click="chooseSelectB('B', enrollItemBanks[testIndex].rightKey)"></div>
              <span>B</span>
            </div>
            <div class="item_circle">
              <div class="circle" :class="selectC ? 'circles' :''" @click="chooseSelectC('C', enrollItemBanks[testIndex].rightKey)"></div>
              <span>C</span>
            </div>
          </div>
          <div class="btn_box">
            <el-button class="item_box" :class="testIndex===0 ? '' :'item_boxs'" @click="lastTest(testIndex)" :disabled="testIndex===0">上一题</el-button>
            <div class="item_word">当前第{{testIndex+1}}题/共计{{total}}道题</div>
            <el-button  :class="testIndex+1===total ? 'item_box' :'item_boxs'" @click="nextTest(testIndex)" :disabled="testIndex+1===total" >下一题</el-button>
            <el-button class="item_boxs" @click="submit()">交卷</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { chessEnrollFractionById, getGjxqEnrollItemBank } from '../../api/index'
export default {
  name: 'chessSelect',
  data () {
    return {
      name: '',
      levelexam: '',
      testId: '',
      exchangCode: '',
      countDownDay: 0,
      countDownHour: 0,
      countDownMinute: 0,
      countDownSecond: 0,
      questionNum: 0,
      enrollItemBanks: [],
      testIndex: 0,
      selectA: false,
      selectB: false,
      selectC: false,
      total: 0,
      selects: [],
      sel: '',
      sum: 0,
      rightKey: [],
      gradId: '',
      totalSecond: 0,
      minute: 60,
      answerC: false,
      flag: true
    }
  },
  created () {
    this.exchangCode = this.$route.params.exchangCode // 获取准考证号
    console.log(this.exchangCode, '准考证号')
    this.questionNum = 10
    this.minute = 60
    this.totalSecond = 3600
    let num = 0
    var interval = setInterval(function () {
      // 秒数
      var second = this.totalSecond
      // 天数位
      var day = Math.floor(second / 3600 / 24)
      var dayStr = day.toString()
      if (dayStr.length === 1) dayStr = '0' + dayStr
      // 小时位
      var hr = Math.floor((second - day * 3600 * 24) / 3600)
      var hrStr = hr.toString()
      if (hrStr.length === 1) hrStr = '0' + hrStr
      // 分钟位
      var min = Math.floor((second - day * 3600 * 24 - hr * 3600) / 60)
      var minStr = min.toString()
      if (minStr.length === 1) minStr = '0' + minStr
      // 秒位
      var sec = second - day * 3600 * 24 - hr * 3600 - min * 60
      var secStr = sec.toString()
      if (secStr.length === 1) secStr = '0' + secStr
      this.countDownDay = dayStr
      this.countDownHour = hrStr
      this.countDownMinute = minStr
      this.countDownSecond = secStr
      this.totalSecond--
      localStorage.setItem('totalSecond', this.totalSecond)
      if (this.totalSecond < 0) {
        clearInterval(interval)
        // 提交答案
        // 跳转页面
        for (var j = 0; j < this.selects.length; j++) {
          if (this.selects[j] === this.rightKey[j]) {
            num++
          }
        }
        // console.log(num)
        this.chessEnrollFractionById(num)
      }
    }.bind(this), 1000)
    if (localStorage.getItem('flag') !== null) {
      this.flag = false
    }
    console.log(localStorage.getItem('flag'))
    // 判断第一次进入
    if (this.flag) {
      this.chessAjax()
    } else {
      this.name = localStorage.getItem('name')
      this.levelexam = localStorage.getItem('levelexam')
      this.enrollItemBanks = JSON.parse(localStorage.getItem('enrollItemBanks'))
      this.total = this.enrollItemBanks.length
      this.questionNum = this.enrollItemBanks.length
      this.selects = localStorage.getItem('selects').split(',')
      this.rightKey = localStorage.getItem('rightKey').split(',')
      this.testIndex = parseInt(localStorage.getItem('index'))
      this.toTegional(this.testIndex)
      this.totalSecond = localStorage.getItem('totalSecond')
      console.log(localStorage.getItem('index'))
    }
  },
  methods: {
    chessAjax () {
      // 请求获取题目信息
      getGjxqEnrollItemBank({
        exchangeCode: this.exchangCode
      }).then(res => {
        // console.log(res, '////////////////////////////////////////////')
        localStorage.setItem('name', res.name)
        localStorage.setItem('levelexam', res.title)
        localStorage.setItem('enrollItemBanks', JSON.stringify(res.gjxqEnrollChoiceItemBanks))
        localStorage.setItem('gjxqEnroll', res.gjxqEnroll)
        localStorage.setItem('flag', false)
        this.name = res.name
        this.levelexam = res.title
        this.enrollItemBanks = res.gjxqEnrollChoiceItemBanks
        this.total = res.gjxqEnrollChoiceItemBanks.length
        this.questionNum = res.gjxqEnrollChoiceItemBanks.length
        this.exchangCode = res.gjxqEnroll.exchangeCode
        this.gradId = res.gjxqEnroll.id
        console.log(this.gradId, 'ID')
      })
    },
    toTegional (index) {
      this.testIndex = index
      localStorage.setItem('index', this.testIndex)
      console.log(index)
      if (this.selects[this.testIndex] === 'A') {
        this.selectA = true
        this.selectB = false
        this.selectC = false
      } else if (this.selects[this.testIndex] === 'B') {
        this.selectB = true
        this.selectA = false
        this.selectC = false
      } else if (this.selects[this.testIndex] === 'C') {
        this.selectC = true
        this.selectA = false
        this.selectB = false
      } else {
        this.selectC = false
        this.selectA = false
        this.selectB = false
      }
    },
    chooseSelectA (selA, right) {
      this.selectA = true
      this.selectB = false
      this.selectC = false
      // console.log(selA, right)
      this.selects[this.testIndex] = selA
      this.rightKey[this.testIndex] = right
      localStorage.setItem('selects', this.selects)
      localStorage.setItem('rightKey', this.rightKey)
      localStorage.setItem('index', this.testIndex)
    },
    chooseSelectB (selB, right) {
      this.selectB = true
      this.selectA = false
      this.selectC = false
      this.selects[this.testIndex] = selB
      this.rightKey[this.testIndex] = right
      localStorage.setItem('selects', this.selects)
      localStorage.setItem('rightKey', this.rightKey)
      localStorage.setItem('index', this.testIndex)
    },
    chooseSelectC (selC, right) {
      this.selectC = true
      this.selectA = false
      this.selectB = false
      this.selects[this.testIndex] = selC
      this.rightKey[this.testIndex] = right
      localStorage.setItem('selects', this.selects)
      localStorage.setItem('rightKey', this.rightKey)
      localStorage.setItem('index', this.testIndex)
    },
    lastTest (index) {
      if (index > 0) {
        this.testIndex--
        localStorage.setItem('index', this.testIndex)
        // eslint-disable-next-line no-unused-expressions
        if (this.selects[this.testIndex] === 'A') {
          this.selectA = true
          this.selectB = false
          this.selectC = false
        } else if (this.selects[this.testIndex] === 'B') {
          this.selectB = true
          this.selectA = false
          this.selectC = false
        } else if (this.selects[this.testIndex] === 'C') {
          this.selectC = true
          this.selectA = false
          this.selectB = false
        } else {
          this.selectC = false
          this.selectA = false
          this.selectB = false
        }
      }
    },
    nextTest (index) {
      if (index <= this.total) {
        this.testIndex++
        localStorage.setItem('index', this.testIndex)
        if (this.selects[this.testIndex] === 'A') {
          this.selectA = true
          this.selectB = false
          this.selectC = false
        } else if (this.selects[this.testIndex] === 'B') {
          this.selectB = true
          this.selectA = false
          this.selectC = false
        } else if (this.selects[this.testIndex] === 'C') {
          this.selectC = true
          this.selectA = false
          this.selectB = false
        } else {
          this.selectC = false
          this.selectA = false
          this.selectB = false
        }
        this.sel = ''
      }
    },
    submit () {
      let sum = 0
      this.$confirm('确认交卷', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        for (var i = 0; i < this.selects.length; i++) {
          if (this.selects[i] === this.rightKey[i]) {
            sum++
          }
        }
        this.chessEnrollFractionById(sum)
      }).catch(() => {
        // console.log('取消')
      })
    },
    chessEnrollFractionById (fraction) {
      chessEnrollFractionById({
        id: this.gradId,
        fraction: fraction
      }).then(res => {
        // success
        // console.log(res, '????????????????')
        // console.log(localStorage.getItem('gjxqEnroll'))
        if (res.success === '1001_1') {
          this.$router.push({
            name: 'chessResults',
            query: {
              id: this.gradId,
              fractions: fraction,
              count: this.questionNum
            }
          })
        }
      }).catch(() => {
      })
    },
    unload (e) {
      e = e || window.event
      if (e) {
        // 在这里阻止默认的刷新，弹出弹框
        e.returnValue = '关闭提示'
      }
      return '关闭'
    }
  },
  mounted () {
    history.pushState(null, null, document.URL)
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL)
    })
    window.addEventListener('beforeunload', this.unload)
    // window.addEventListener('beforeunload', e => this.unload) // 注册一个匿名函数
  },
  // 2 销毁这个监听事件
  destroyed () {
    // 销毁这个监听事件，需要找到这个函数，如果使用的是匿名函数的话，无法查找这个函数，这个事件也就没有办法被移除 ，在其他页面仍然会执行这个监听事件
    window.removeEventListener('beforeunload', this.unload)
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/base.scss";
  @import "../../assets/scss/mixin.scss";
  @import "../../assets/scss/config.scss";
  .header{
    width:100%;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
    height: 140px;
    background-color: #008EE9;
    .top{
      width: 100%;
      @media only screen and (min-width: 540px) and (max-width: 1180px){
        width: 1180px;
      }
      height: 140px;
      @include flex();
      padding: 0 95px;
      margin: 0 auto;
      box-sizing: border-box;
      .title{
        background-color: #008de9;
        color: #fff;
        font-size: 50px;
        font-family: 'SimSun';
        font-weight: bold;
      }
    }
  }
  .container{
    box-sizing: border-box;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
    .dotest{
      box-sizing: border-box;
      height: 40px;
      width: 100%;
      border-bottom: 1px solid #cecece;
      @include flex();
      margin-top: 30px;
      .left{
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #EF0404;
      }
      .right{
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        .time{
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #EF0404;
        }
      }
    }
    .dotest_content{
      box-sizing: border-box;
      margin-top: 40px;
      margin-bottom: 90px;
      @include flexed();
      .item_left{
        width: 225px;
        margin-right: 24px;
        .info{
          width: 225px;
          height: 201px;
          border: 1px solid #cecece;
          padding: 20px 30px;
          box-sizing: border-box;
          margin-bottom: 20px;
          .item_title{
            width: 100%;
            text-align: center;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }
          .item_info{
            width: 100%;
            text-align: left;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            margin: 10px 0;
          }
        }
        .select {
          width: 225px;
          border: 1px solid #cecece;
          padding: 10px 30px 20px;
          box-sizing: border-box;
          @include flexed();
          .item_choose{
            width: 20px;
            height: 20px;
            border: 1px solid #cecece;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            text-align: center;
            line-height: 20px;
            margin-top: 10px;
            margin-right: 13px;
            &:nth-child(5n){
              margin-right: 0;
            }
            cursor: pointer;
          }
          .item_chooses{
            background-color: #008DE9;
            border: 1px solid #008DE9;
            color: #ffffff;
          }
        }
      }
      .item-rigts{
        width: 931px;
        border: 1px solid #cecece;
        padding-top: 59px;
        padding-bottom: 59px;
        box-sizing: border-box;
        .cons{
          width: 100%;
          border-bottom: 1px solid #cecece;
          .testtitle{
            width: 100%;
            font-size: 16px;
            margin:0 47px;
            box-sizing: border-box;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            span{
              display: inline-block;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #008DE9;
              margin-right: 10px;
            }
          }
          .testimg{
            width: 259px;
            height: 291px;
            margin:15px 47px;
            box-sizing: border-box;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .selected{
            margin:0 47px;
            margin-top: 5px;
            margin-bottom: 10px;
            box-sizing: border-box;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            span{
              display: inline-block;
              margin-right: 3px;
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }
          }
        }
        .selects{
          padding:0 47px;
          height: 50px;
          box-sizing: border-box;
          margin-top: 10px;
          .item_circle{
            display: inline-block;
            margin-right: 32px;
            margin-bottom: 70px;
            .circle{
              width: 12px;
              height: 12px;
              border: 1px solid #999999;
              border-radius: 50%;
              display: inline-block;
            }
            .circles{
              background-color: #008DE9;
            }
            span{
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              display: inline-block;
              margin-left: 8px;
            }
          }
        }
        .btn_box{
          padding-left: 165px;
          box-sizing: border-box;
          .item_box{
            display: inline-block;
            width: 131px;
            height: 52px;
            background: #999999;
            text-align: center;
            line-height: 52px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
            margin: 0;
            padding: 0;
            border-radius: 0;
          }
          .item_word{
            display: inline-block;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            margin-left: 50px;
            margin-right: 50px;
          }
          .item_boxs{
            display: inline-block;
            width: 131px;
            height: 52px;
            background: #008DE9;
            text-align: center;
            line-height: 52px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
            margin: 0;
            padding: 0;
            border-radius: 0;
            &:last-child{
              margin-left: 60px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/chess_test/chessSelect.vue